<template>
  <div
    class="user-toolbar d-flex align-center justify-end flex-wrap"
    data-testid="setup-users__toolbar"
  >
    <div class="user-toolbar__actions d-flex align-center">
      <v-btn
        v-if="hasActiveTableFilter"
        text
        small
        class="text-none"
        data-testid="setup-users__clear-filters"
        @click="$emit('clear-filters')"
      >
        Clear Filter
      </v-btn>

      <!-- Add user hidden (NXTGEN-7362). Keep block for when ADD_USER_ENABLED is true. -->
      <v-tooltip
        v-if="ADD_USER_ENABLED"
        bottom
        content-class="tooltip-bottom"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn
              small
              color="primary"
              class="text-none white--text"
              data-testid="setup-users__add-user-btn"
              @click="onAddClick"
            >
              Add user
            </v-btn>
          </div>
        </template>
        <span>Add user</span>
      </v-tooltip>

      <v-menu
        offset-y
        transition="slide-y-transition"
        :close-on-content-click="true"
        content-class="user-toolbar__more-menu-panel"
        data-testid="setup-users__more-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            class="shadow-off"
            aria-label="More actions"
            data-testid="setup-users__more-menu-btn"
          >
            <img
              src="/img/icons/threedot.svg"
              alt="More actions"
              class="user-toolbar__more-menu-img rotate-90"
            />
          </v-btn>
        </template>
        <div class="user-toolbar__more-menu" data-testid="setup-users__more-menu-list">
          <div class="user-toolbar__more-menu-body">
            <button
              type="button"
              class="user-toolbar__more-menu-item"
              @click.stop="openActivityLog"
              data-testid="setup-users__more-menu-activity-log"
            >
              <span class="user-toolbar__more-menu-item-content">
                <img
                  src="/img/icons/activity-log.svg"
                  alt=""
                  class="user-toolbar__more-menu-img"
                />
                <span class="user-toolbar__more-menu-label">Activity Log</span>
              </span>
            </button>
          </div>
        </div>
      </v-menu>

      <activity-log
        hide-trigger
        ref="activityLog"
        consolidated
        :module-name="activityLogModuleName"
        data-testid="setup-users__activity-log"
      />
    </div>
  </div>
</template>

<script>
import './UserToolbar.scss';
import ActivityLog from '@/modules/financialclose/components/ActivityLog/ActivityLog.vue';
import {
  ACTIVITY_LOG_MODULE_NAME,
  ADD_USER_ENABLED,
  PAGE_DETAILS,
} from '../../utils/userConstants';

export default {
  name: 'UserToolbar',

  components: {
    ActivityLog,
  },

  props: {
    hasActiveTableFilter: {
      type: Boolean,
      default: false,
    },
    pageDetails: {
      type: Object,
      default: () => ({ ...PAGE_DETAILS }),
    },
  },

  data() {
    return {
      ADD_USER_ENABLED,
      activityLogModuleName: ACTIVITY_LOG_MODULE_NAME,
    };
  },

  methods: {
    onAddClick() {
      this.$emit('add-user');
    },

    openActivityLog() {
      const activityLog = this.$refs.activityLog;
      if (activityLog && typeof activityLog.openDialog === 'function') {
        activityLog.openDialog();
        return;
      }
      this.$nextTick(() => {
        this.$refs.activityLog?.openDialog();
      });
    },
  },
};
</script>
